import { useCallPreferencesContext, type VideoQualityPreset } from "./useCallPreferences"

/** Prebuilt's Video quality tab, with its copy. */
export const VIDEO_QUALITY_OPTIONS: Array<{ id: VideoQualityPreset; label: string; hint?: string; description: string }> = [
  { id: "auto", label: "Auto", hint: "(High quality)", description: "Video quality is automatically adjusted based on network conditions." },
  { id: "high", label: "High quality", description: "Video is always set to the highest quality possible." },
  { id: "low", label: "Low quality", description: "Video may be pixelated. Best for slow connections." },
  { id: "bandwidth-saver", label: "Bandwidth saver", description: "Your camera is turned off. You'll receive low quality video from others. Best for mobile or poor connections." },
]

export function VideoQualitySettings() {
  const { preferences, updatePreferences } = useCallPreferencesContext()
  return (
    <div data-testid="call-video-quality-settings" className="space-y-3">
      <p className="text-sm font-semibold text-white">Select the video quality that&apos;s best for your network.</p>
      <div role="radiogroup" aria-label="Video quality" className="space-y-2">
        {VIDEO_QUALITY_OPTIONS.map((option) => {
          const checked = preferences.videoQuality === option.id
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={checked}
              onClick={() => updatePreferences({ videoQuality: option.id })}
              className={`flex w-full items-start gap-3 rounded-xl border px-3 py-2 text-left transition-colors ${checked ? "border-[#f6a35c] bg-[#f6a35c]/10" : "border-white/10 bg-white/5 hover:bg-white/10"}`}
            >
              <span className={`mt-1 h-3.5 w-3.5 shrink-0 rounded-full border-2 ${checked ? "border-[#f6a35c] bg-[#f6a35c]" : "border-white/40"}`} aria-hidden="true" />
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-white">
                  {option.label}
                  {option.hint && <span className="ml-1 font-normal text-white/60">{option.hint}</span>}
                </span>
                <span className="block text-xs text-white/60">{option.description}</span>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
